import {Pipe, PipeTransform} from '@angular/core';
import {DcColorType} from '@shared-types';

/**
 * @description Applies the theme color to the given class template.
 */
@Pipe({
	name: 'themeApply',
	standalone: true,
})
export class ThemeApplyPipe implements PipeTransform {
	transform(color: DcColorType, classTemplate?: string): unknown {
		if (!classTemplate.includes('*')) return classTemplate;
		return classTemplate?.replace('*', color);
	}
}
